import styled from "styled-components";

export const Container = styled.div`
    overflow-x: hidden;
    @media (min-width: 576px) {
        max-width: 540px;
        margin: 0 auto;
        text-align: center;
    }

    @media (min-width: 768px) {
        max-width: 720px;
        margin: 0 auto;
        text-align: center;
    }

    @media (min-width: 992px) {
        max-width: 960px;
        margin: 0 auto;
        text-align: center;
    }

    @media (min-width: 1200px) {
        max-width: 1600px;
        margin: 0 auto;
        text-align: center;
    }

    .primary {
        width: 80%;
        text-align: center;
        margin: 0 auto;
    }

    .alertaimg {
        width: 50%;
    }

    .corpotextomanutencao {
        font-size: 40px;
        color: #303030;
        margin-top: 3%;
        margin-bottom: 5%;
    }
`;
